import { eAccHinhThucNopTienActionsObj } from "./../../action-types/category/IAccHinhThucNopTien";
import { NotifyHelper } from "../../../helpers/toast";
import { generateActionForKey, generateActions } from "../generateActions";

export const hinhThucNopTienActions = {
  ...generateActions(eAccHinhThucNopTienActionsObj, "HINH_THUC_NOP_TIEN"),
  ...generateActionForKey(
    eAccHinhThucNopTienActionsObj,
    "HINH_THUC_NOP_TIEN",
    "SAVE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã cập nhật");
    }
  ),
  ...generateActionForKey(
    eAccHinhThucNopTienActionsObj,
    "HINH_THUC_NOP_TIEN",
    "SAVE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eAccHinhThucNopTienActionsObj,
    "HINH_THUC_NOP_TIEN",
    "DELETE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã xóa");
    }
  ),
  ...generateActionForKey(
    eAccHinhThucNopTienActionsObj,
    "HINH_THUC_NOP_TIEN",
    "DELETE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
};
